<h2 mat-dialog-title>
  <mat-icon color="warn">warning</mat-icon>
  Pendências para Consolidação
</h2>

<mat-dialog-content>
  <div class="pendencias-container">
    <mat-card *ngIf="data.examinadoresSemMalote && data.examinadoresSemMalote.length > 0" class="pendencia-card">
      <mat-card-header>
        <mat-icon color="warn">person_off</mat-icon>
        <mat-card-title>Examinadores sem Malote</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Os seguintes examinadores ainda não enviaram seus malotes</p>
        <p>(Conjunto de envelopes da fase):</p>
        <ul>
          <li *ngFor="let examinador of data.examinadoresSemMalote">{{ examinador }}</li>
        </ul>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="data.examinadoresComNotasEmpatadas && data.examinadoresComNotasEmpatadas.length > 0" class="pendencia-card">
      <mat-card-header>
        <mat-icon color="warn">gavel</mat-icon>
        <mat-card-title>Examinadores com Notas Empatadas</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Os seguintes examinadores possuem notas empatadas que precisam ser resolvidas:</p>
        <ul>
          <li *ngFor="let examinador of data.examinadoresComNotasEmpatadas">{{ examinador }}</li>
        </ul>
      </mat-card-content>
    </mat-card>

    <div class="alerta-info">
      <mat-icon>info</mat-icon>
      <span>Resolva todas as pendências antes de consolidar a fase.</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="fechar()">
    <mat-icon>close</mat-icon>
    Fechar
  </button>
</mat-dialog-actions>
